import { BaseService } from "@/api/base-service";
import type { Room, UpdateGymRoomPayload } from "./types";

export class RoomsService extends BaseService {
  static get instance() {
    return this.getInstance<RoomsService>();
  }

  public async getRooms(id: number): Promise<{ gymRooms: Room[] }> {
    return this.client.get<{ gymRooms: Room[] }>(`/gyms/${id}/gym_rooms`);
  }

  public async getRoom(gymId: string, id: string): Promise<Room> {
    const response = await this.client.get<{ gymRoom: Room }>(
      `/gyms/${gymId}/gym_rooms/${id}`,
    );

    return response.gymRoom;
  }

  public async deleteRooms(
    gymId: string,
    gymRoomsIds: number[],
  ): Promise<void> {
    await this.client.delete(`/gyms/${gymId}/gym_rooms`, {
      data: {
        ids: gymRoomsIds,
      },
    });
  }

  public async updateRoom(
    gymId: string,
    id: string,
    data: UpdateGymRoomPayload["gym_room"],
  ): Promise<Room> {
    const response = await this.client.put<{ gymRoom: Room }>(
      `/gyms/${gymId}/gym_rooms/${id}`,
      {
        gym_room: data,
      },
    );

    return response.gymRoom;
  }

  public async createRoom(
    gymId: string,
    data: UpdateGymRoomPayload["gym_room"],
  ): Promise<Room> {
    const response = await this.client.post<{ gymRoom: Room }>(
      `/gyms/${gymId}/gym_rooms`,
      {
        gym_room: data,
      },
    );

    return response.gymRoom;
  }
}
